// @core/api/endpoints/document/get_document_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentTemplateResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get template
 * Returns a document template by ID.
 */
export async function GetDocumentTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<DocumentTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.get<DocumentTemplateResponse>(requestPath, { ...requestOptions });
}
